import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import React from 'react';

const StyledButton = styled.button<{ size: number }>`
  outline: none;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.secondaryColor};
  height: ${(props) => props.size || 40}px;
  min-width: ${(props) => props.size || 40}px;
  max-width: ${(props) => props.size || 40}px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  position: relative;
  &:hover {
    background-color: ${(props) => props.theme.colors.secondaryHoverColor};
    border-color: ${(props) => props.theme.colors.primaryColor};
  }
  &.active {
    background-color: ${(props) => props.theme.colors.secondaryHoverColor};
    border-color: ${(props) => props.theme.colors.primaryColor};
  }
`;


type IconButtonProps = {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
  active?: boolean;
  labelPosition?:
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';
  size?: number;
};

const IconButton = ({ children, onClick, label, labelPosition, active, size }: IconButtonProps) => {
  const Jsx = (
    <StyledButton size={size} className={active ? 'active' : ''} onClick={onClick}>
      {children}
    </StyledButton>
  );
  if (!label) {
    return (
      <>
        {Jsx}
      </>
    );
  }
  return (
    <Tooltip placement={labelPosition || 'bottom'} title={label || ''} >
      {Jsx}
    </Tooltip>
  );
};

export default IconButton;
